import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const RenewalsDetailPaper = ({
  classes,
  paperTitle,
  createRenewalsTableColumns,
  handleChangeLocation,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            Renewals tracker detail – Month of XXX
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ResizableTable
              columns={createRenewalsTableColumns()}
              rows={[
                {
                  rowNum: 1,
                  customerName: "Customer Alpha",
                  renewalDate: "2026-03-15",
                  contractValue: 2.5,
                  probability: 90,
                  status: "On Track",
                  riskFactors: "None",
                  actionItems: "Schedule QBR",
                  label: "Customer Alpha",
                },
                {
                  rowNum: 2,
                  customerName: "Customer Beta",
                  renewalDate: "2026-03-20",
                  contractValue: 1.8,
                  probability: 75,
                  status: "At Risk",
                  riskFactors: "Budget concerns",
                  actionItems: "Executive engagement needed",
                  label: "Customer Beta",
                },
                {
                  rowNum: 3,
                  customerName: "Customer Gamma",
                  renewalDate: "2026-03-25",
                  contractValue: 3.2,
                  probability: 95,
                  status: "Committed",
                  riskFactors: "None",
                  actionItems: "Send contract",
                  label: "Customer Gamma",
                },
                {
                  rowNum: null,
                  customerName: "TOTAL",
                  renewalDate: null,
                  contractValue: 7.5,
                  probability: null,
                  status: null,
                  riskFactors: null,
                  actionItems: null,
                  label: "Total",
                },
              ]}
              getCellValue={(row, field, rowIndex) => {
                // Always show sequential row numbers regardless of sort order
                if (field === "rowNum") {
                  // For Total rows, return null
                  if (row.label === "Total") {
                    return null;
                  }
                  // For regular rows, use rowIndex to show sequential numbers
                  return rowIndex != null
                    ? rowIndex + 1
                    : row[field] != null
                      ? row[field]
                      : "";
                }
                if (
                  row.label === "Total" &&
                  field !== "customerName" &&
                  field !== "contractValue"
                ) {
                  return "";
                }
                return row[field] != null ? row[field] : "";
              }}
              getCellStyle={(row, field) => {
                if (row.label === "Total") {
                  return { fontWeight: 600, backgroundColor: "#f5f5f5" };
                }
                return {};
              }}
              rowKey="label"
              hideSubHeaderRow={true}
              maxWidth="100%"
              onRowClick={(row) =>
                handleChangeLocation("drilldownOnGraph", row, "renewals")
              }
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default RenewalsDetailPaper;
